import { get } from "../http";
import { logSentry } from "../sentry";
declare const window: any;

export const getPantoneColor = async () => {
    try {
        let url = window?.Config?.LAMBDA_PANTONE_CDN || `https://cdn-npr-customize.api.pens.com/v1/imprintInfo/pantoneColors`;
        const { data: pantoneColors } = await get(url, { "regionCode": `${window.appConfig.regionCode}`, "lang": `${window.appConfig.language}` });
        return pantoneColors;
    } catch (error) {
        logSentry({
            'page': 'shoppingPage',
            'feature': 'loadConfigs',
            'operation': 'loadConfigs',
            'errorType': 'ajaxError',
            'err': JSON.stringify(error),
            'func': 'loadConfigs --> getPantoneColor',
            'api': 'https://cdn-customize.api.pens.com/v1/imprintInfo/pantoneColors',
            'errMsg': 'Error: while getting pantone color'
        })
    }
};